import EBRMaterialsServiceDetail from "./EBRMaterialsServiceDetail";

export default EBRMaterialsServiceDetail;
